import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import {
  TerminalCatalogQuery,
  TerminalCatalogRepository,
} from '@app/domain/ports/tpv/terminal-catalog.repository';
import { TpvTerminal } from '@app/domain/models/tpv/terminal.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';

/** Comercios de la maqueta del catálogo (feature 151). */
export const MOCK_CATALOG_MERCHANT_A = 'mock-merchant-a';
export const MOCK_CATALOG_MERCHANT_B = 'mock-merchant-b';

function mockTerminal(idTerminal: string, externalIdMerchant: string, serialNumber: string | null): TpvTerminal {
  return {
    idTerminal,
    externalIdMerchant,
    companyName: 'Demo 1 SA de CV',
    merchantName: externalIdMerchant === MOCK_CATALOG_MERCHANT_A ? 'Comercio Demo A' : 'Comercio Demo B',
    affiliation: '1234567',
    os: 'Android 12',
    lastActivity: '2026-10-14T10:00:00Z',
    status: 'active',
    serialNumber,
  };
}

/**
 * Catálogo de maqueta con los casos borde de R19: seriales normales, uno
 * repetido en dos terminales, uno sin serial (`null`), uno vacío, la
 * pseudo-terminal `001` y uno con sufijo `:420`, repartidos en dos comercios.
 * Las PK imitan las de prod (nunca iguales al serial).
 */
export const MOCK_TERMINAL_CATALOG: readonly TpvTerminal[] = [
  mockTerminal('e382449c0be1badfbb0b939e', MOCK_CATALOG_MERCHANT_A, 'P651900030610'),
  mockTerminal('P651900012757:3', MOCK_CATALOG_MERCHANT_A, 'P651900012757'),
  mockTerminal('a1b2c3d4e5f60718293a4b5c', MOCK_CATALOG_MERCHANT_A, null),
  mockTerminal('ecommerce-a', MOCK_CATALOG_MERCHANT_A, '001'),
  mockTerminal('b2c3d4e5f60718293a4b5c6d', MOCK_CATALOG_MERCHANT_B, 'P651900099999'),
  mockTerminal('c3d4e5f60718293a4b5c6d7e', MOCK_CATALOG_MERCHANT_B, 'P651900030610'),
  mockTerminal('d4e5f60718293a4b5c6d7e8f', MOCK_CATALOG_MERCHANT_B, ''),
  mockTerminal('e5f60718293a4b5c6d7e8f90', MOCK_CATALOG_MERCHANT_B, 'P651900030613:420'),
];

/** Maqueta del catálogo (`tpvUseMocks`): filtra por comercio y pagina con `slice`. */
@Injectable()
export class TerminalCatalogMockDataSource extends TerminalCatalogRepository {
  override getCatalogPage(query: TerminalCatalogQuery): Observable<TpvPage<TpvTerminal>> {
    const scoped = query.merchantId
      ? MOCK_TERMINAL_CATALOG.filter((t) => t.externalIdMerchant === query.merchantId)
      : MOCK_TERMINAL_CATALOG;
    const start = (query.page - 1) * query.limit;
    return of({
      data: scoped.slice(start, start + query.limit),
      total: scoped.length,
      page: query.page,
      limit: query.limit,
    }).pipe(delay(300));
  }
}
